<template>
  <div class="promoter-customer-list">
    <div class="customer-item" v-for="item in customerList" :key="item.customer_id">
      <div class="content">
        <div class="customer-title">用户 {{ item.customer_id }}</div>
        <div class="customer-status" :class="getRelationClass(item)">
          <span>{{ getRelationText(item) }}</span>
        </div>
      </div>
      <div class="footer">
        <div class="date">注册: {{ formatFullDate(item.dt_created) }}</div>
        <div class="date">关联: {{ formatFullDate(item.promoter_dt) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatFullDate } from '@/plugins/datefmt'

export default {
  props: {
    customerList: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatFullDate,
    getRelationText(item) {
      let map = {
        first: '拉新',
        latest: '抢客',
        final: '绑定',
        failedfirst: '已被抢客',
        failedlatest: '抢客失败',
      }
      return map[item.promoter_relation] || item.promoter_relation
    },
    getRelationClass(item) {
      return ['is-' + item.promoter_relation]
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/common';

.promoter-customer-list {
  background: @antBackWhite;
}

.customer-item {
  padding-top: 16px;
  padding-bottom: 16px;
  border-top: solid 1px @antLineGrey;

  &:first-child {
    border: none;
  }

  .header,
  .content,
  .footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .header,
  .footer {
    color: @antTextGrey;
  }

  .content {
    font-size: 18px;
    padding: 4px 0;
  }

  .customer-status {
    &.is-first {
      color: @antGreen;
    }
    &.is-latest {
      color: @antGold;
    }
    &.is-final {
      color: @antBlue;
    }
  }

  .date {
    font-size: 12px;
  }
}
</style>
